import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import GroupedTickets from '../GroupedTickets';
import PriceDetails from '../PriceDetails';
import { selectCartCurrency, selectCartTotal } from '../../selectors';
import formatFloatWithSuperscript from '../../../core/utils/helpers';

const OrderMobile = ({ open, tickets }) => {
    const total = useSelector(selectCartTotal);
    const currency = useSelector(selectCartCurrency);
    return (
        <>
            <Accordion defaultActiveKey={open ? '0' : null}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <span className="d-flex w-100">
                            <strong className="text-capitalize">Total</strong>
                            <strong className="ms-auto">{formatFloatWithSuperscript(total)} {currency}</strong>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <Accordion.Header>
                            <p className="text-muted me-auto"><FormattedMessage id="cart_your_order"/></p>
                            <i className="bi bi-x-lg"/>
                        </Accordion.Header>
                        <PriceDetails showTotal={false}>
                            <GroupedTickets tickets={tickets} currency={currency}/>
                        </PriceDetails>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};
export default OrderMobile;
